import { getRect } from "lib/utils/domsUtil";
import { createContext, FC, useCallback, useContext, useEffect, useState } from "react";
import { HelpPoint } from "./helpPoint";
import { v4 as uuidv4 } from 'uuid';

const HelpContext = createContext(null);

export const HelpProvider: FC = ({ children }) => {
  const [isHelpActive, setIsHelpActive] = useState(false);
  const [activeHelpId, setActiveHelpId] = useState(null);
  const [points, setPoints] = useState([]);

  const showHelp = () => {
    handleResize();
    setIsHelpActive(true);
  }
  
  const hideHelp = () => setIsHelpActive(false);

  const handleResize = useCallback(() => {
    const selectors = Array.from(document.querySelectorAll('[data-help]'));
    setPoints(selectors.map(s => {
      const sizes = getRect(s);
      return {
        content: s.getAttribute('data-help'),
        id: uuidv4(),
        ...sizes,
      }
    }));
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
    const { target: { id }} = e;

    if (id.startsWith('help-')) {
      return;
    }

    return setActiveHelpId(null);
  }

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', handleResize)
    return () => {
      window.removeEventListener('scroll', handleResize)
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize]);

  useEffect(() => {
    handleResize();
    window.addEventListener('click', handleClick)
    return () => {
      window.removeEventListener('click', handleClick)
    }
  }, []);

  return (
    <HelpContext.Provider value={{ showHelp, hideHelp, isHelpActive }}>
      {children}
      {
        isHelpActive && (
          points.map((data, index) => (
            <HelpPoint
              key={`${data.left}_${index}`}
              data={data}
              activeHelpId={activeHelpId}
              setActiveHelpId={setActiveHelpId}
            />
          ))
        )
      }
    </HelpContext.Provider>
  )
}

export const useHelpContext = () => useContext(HelpContext);
